import { render, staticRenderFns } from "./DancersList.vue?vue&type=template&id=97651fa4&scoped=true&"
import script from "./DancersList.vue?vue&type=script&lang=ts&"
export * from "./DancersList.vue?vue&type=script&lang=ts&"
import style0 from "./DancersList.vue?vue&type=style&index=0&id=97651fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97651fa4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97651fa4')) {
      api.createRecord('97651fa4', component.options)
    } else {
      api.reload('97651fa4', component.options)
    }
    module.hot.accept("./DancersList.vue?vue&type=template&id=97651fa4&scoped=true&", function () {
      api.rerender('97651fa4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/components/DancersList.vue"
export default component.exports